var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "table-contact-list-container",
      class: { "virtual-mode": _vm.selectedGroup !== "none" },
    },
    [
      _c(
        "div",
        {
          ref: "mainContainer",
          staticClass: "table-contact-list",
          on: { scroll: _vm.onMainScroll },
        },
        [
          _vm.selectedContacts.length === 0
            ? _c("div", { staticClass: "table-header" }, [
                _c("div", { staticClass: "header-content" }, [
                  _c("div", { staticClass: "title-section" }, [
                    _c("div", { staticClass: "filter-icon" }, [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v(_vm._s(_vm.filterIcon)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "title-text" }, [
                      _c("span", { staticClass: "filter-name" }, [
                        _vm._v(_vm._s(_vm.filterName)),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "header-actions" },
                    [
                      _vm.filter && !_vm.editMode
                        ? _c(
                            "SupsisButton",
                            {
                              staticClass: "edit-filter-btn",
                              on: { click: _vm.onEditFilter },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.$t("chat.tableContactList.editFilter")
                                  ) +
                                  "\n                    "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.editMode
                        ? _c(
                            "div",
                            { staticClass: "edit-mode-actions" },
                            [
                              _c(
                                "SupsisButton",
                                {
                                  staticClass: "cancel-btn",
                                  on: { click: _vm.onCancelEditFilter },
                                },
                                [_vm._v(_vm._s(_vm.$t("message.cancel")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "SupsisButton",
                                {
                                  staticClass: "save-btn",
                                  attrs: { primary: "" },
                                  on: { click: _vm.onSaveFilterChanges },
                                },
                                [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("save"),
                                  ]),
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.$t("common.save")) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedGroup === "none" &&
                      _vm.localContacts.length > 0 &&
                      !_vm.editMode
                        ? _c(
                            "div",
                            { staticClass: "pagination-controls-compact" },
                            [
                              _c(
                                "div",
                                { staticClass: "page-size-selector" },
                                [
                                  _c(
                                    "a-select",
                                    {
                                      staticStyle: { width: "80px" },
                                      attrs: { size: "small" },
                                      on: { change: _vm.onPageSizeChange },
                                      model: {
                                        value: _vm.cursor.limit,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.cursor, "limit", $$v)
                                        },
                                        expression: "cursor.limit",
                                      },
                                    },
                                    [
                                      _c(
                                        "a-select-option",
                                        { attrs: { value: 10 } },
                                        [_vm._v("10")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a-select-option",
                                        { attrs: { value: 20 } },
                                        [_vm._v("20")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a-select-option",
                                        { attrs: { value: 50 } },
                                        [_vm._v("50")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a-select-option",
                                        { attrs: { value: 100 } },
                                        [_vm._v("100")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "pagination-buttons" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass: "pagination-btn-compact",
                                    attrs: {
                                      disabled:
                                        !_vm.cursor.prevToken || _vm.loading,
                                    },
                                    on: { click: _vm.goToPrevPage },
                                  },
                                  [
                                    _c("i", { staticClass: "material-icons" }, [
                                      _vm._v("chevron_left"),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "pagination-btn-compact",
                                    attrs: {
                                      disabled:
                                        !_vm.cursor.nextToken || _vm.loading,
                                    },
                                    on: { click: _vm.goToNextPage },
                                  },
                                  [
                                    _c("i", { staticClass: "material-icons" }, [
                                      _vm._v("chevron_right"),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.editMode
            ? _c("FiltersSection", {
                attrs: {
                  "sort-disabled": true,
                  filters: _vm.editingFilters,
                  state: _vm.state,
                  sort: _vm.sortValue,
                },
                on: { "filters-changed": _vm.onEditingFiltersChanged },
              })
            : _vm.selectedContacts.length > 0
            ? _c("BulkActionsBar", {
                attrs: {
                  "selected-count": _vm.selectedContacts.length,
                  "selected-contacts": _vm.selectedContactsData,
                },
                on: {
                  close: _vm.clearSelection,
                  "select-all": _vm.selectAllContacts,
                  "deselect-all": _vm.clearSelection,
                  "bulk-action-complete": _vm.onBulkActionComplete,
                },
              })
            : _c("div", { staticClass: "table-filter-section" }, [
                _c("div", { staticClass: "filters-section" }, [
                  _c("div", { staticClass: "state-and-group-selectors" }, [
                    _c(
                      "div",
                      { staticClass: "state-selector" },
                      [
                        _c(
                          "a-tooltip",
                          {
                            attrs: {
                              placement: "top",
                              title:
                                _vm.$t("chat.tableContactList.chatStatus") +
                                ": " +
                                _vm.getStatusTitle(_vm.effectiveState),
                              "mouse-enter-delay": 0.4,
                            },
                          },
                          [
                            _c("MinimalPopoverSelect", {
                              staticClass: "state-selector",
                              attrs: {
                                value: _vm.effectiveState,
                                options: _vm.stateOptions,
                                icon: "layers",
                                "show-dropdown-arrow": false,
                                "button-class": "chip",
                              },
                              on: { change: _vm.onStateChange },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "group-selector" },
                      [
                        _c(
                          "a-tooltip",
                          {
                            attrs: {
                              placement: "top",
                              title: _vm.$t("chat.tableContactList.grouping"),
                              "mouse-enter-delay": 0.4,
                            },
                          },
                          [
                            _c("MinimalPopoverSelect", {
                              staticClass: "group-selector",
                              attrs: {
                                value: _vm.selectedGroup,
                                options: _vm.groupOptions,
                                icon: "group_work",
                                "show-dropdown-arrow": false,
                                "button-class": "chip",
                                "filter-name": _vm.$t(
                                  "chat.tableContactList.grouping"
                                ),
                              },
                              on: { change: _vm.onGroupChange },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "contact-list-view" },
            [
              _c("ContactList", {
                ref: "contactList",
                attrs: {
                  contacts: _vm.allContacts,
                  loading: _vm.loading,
                  groups: _vm.selectedGroup !== "none" ? _vm.groupValues : [],
                  "scroll-loading": _vm.selectedGroup !== "none",
                  "table-local-storage-key":
                    "contact-table-" + (_vm.filterId || "default"),
                  "scroll-top": _vm.scrollTop,
                  "container-height": _vm.containerHeight,
                  selectable: true,
                  "max-select-count": 500,
                  filterable: true,
                  filters: _vm.tableFilters,
                  "sort-field": _vm.sortField,
                  "sort-direction": _vm.sortDirection,
                },
                on: {
                  "scroll-load": _vm.onScrollLoad,
                  "selection-change": _vm.onSelectionChange,
                  "filter-toggle": _vm.onFilterToggle,
                  "sort-change": _vm.onSortChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("FilterNameModal", {
        attrs: {
          visible: _vm.showFilterNameModal,
          "filter-name": _vm.pendingFilterName,
          "suggested-name": _vm.pendingSuggestedName,
        },
        on: {
          confirm: _vm.confirmFilterName,
          cancel: _vm.cancelFilterName,
          "update-suggested-name": _vm.updateSuggestedName,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }